import React from 'react';

export const Dashboard: React.FC = () => {
  return <></>;
};
